import { styled, Grid } from '@mui/material';
import React from 'react';
import { TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS } from '../../utils/constants/Constants.js';
import { GenericContainer, PreloadFonts } from '../components/GenericContainer.js';
import { BrandclubVideo } from '../components/BrandclubVideo.js';

var _a, _b;
var HeaderContainer = styled(GenericContainer)((_a = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: "0 5%",
        boxSizing: 'border-box',
        marginTop: 30
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        marginTop: 0,
        backgroundColor: '#fff',
        padding: "20px ".concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        marginTop: 0,
        backgroundColor: '#fff',
        padding: "20px ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var HeaderDetails = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            zIndex: 1,
            fontFamily: 'Poppins',
            color: theme.palette.primary.main,
            padding: '0px 0px',
            boxSizing: 'border-box',
            maxWidth: 1000,
            // maxHeight: '80%',
            left: 0,
            textAlign: 'center',
            marginBottom: 25,
            '.title': {
                fontSize: 60,
                fontWeight: 'bold',
            },
            '.desc': {
                margin: '0',
                fontSize: 22,
                fontWeight: 500,
            }
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            marginBottom: 15,
            '.title': {
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 'bold',
                width: '100%',
            },
            '.desc': {
                textAlign: 'center',
                paddingTop: 5,
                margin: '',
                fontSize: 16,
                fontWeight: 500,
                width: '100%',
            },
        },
        _b);
});
var HeroContainer = styled(Grid)({
    flexDirection: 'column',
    maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '.headerImage': {
        // aspectRatio: '5/1',
        borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
        overflow: 'hidden',
        objectFit: 'cover',
        width: '100%',
    },
});
var HeaderItemDesc = styled('div')(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ({
        div: {
            textDecoration: 'none',
            color: theme.palette.primary.main,
            width: '100%',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
        },
        '.title': (_b = {
                margin: '10px 0 0 0',
                fontSize: 20,
                fontWeight: 'bold',
                WebkitLineClamp: 1,
                lineHeight: '1.3'
            },
            _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = { fontSize: 16 },
            _b),
        '.subtitle': (_c = {
                WebkitLineClamp: 2,
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '1.57',
                height: 44
            },
            _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = { fontSize: 12, height: 40 },
            _c),
    });
});
var HeaderContentContainer = styled(Grid)((_b = {
        display: 'grid',
        gridTemplateColumns: 'repeat(4,1fr)',
        gap: '0 3%',
        'div:nth-child(2)': {
            alignSelf: 'start',
        },
        'div:nth-child(3)': {
            alignSelf: 'start',
        },
        'div:nth-child(4)': {
            alignSelf: 'end',
        },
        'div:nth-child(5)': {
            alignSelf: 'end',
        }
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        gridTemplateColumns: 'repeat(2,1fr)',
        gap: '20px 3%',
    },
    _b));
var HeaderCardContainer = styled('div')({
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'space-between',
    gridRow: '1 / span 2',
    gridColumn: '1 / span 2',
    img: {
    // borderRadius: 5,
    // width: '100%',
    // aspectRatio: '340/273',
    // objectFit: 'cover',
    // objectPosition: 'center',
    },
    '.header_item_image': {
        display: 'flex',
        width: '100%',
        aspectRatio: '340/273',
        borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
        background: 'black',
    },
});
var HeaderItemCardContainer = styled('div')({
    img: {
        borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
        width: '100%',
        aspectRatio: '322/212',
        objectFit: 'cover',
        objectPosition: 'center',
    },
    '.header_item_image': {
        display: 'flex',
        width: '100%',
        aspectRatio: '322/212',
    },
});
var HeaderCard = function (_a) {
    var _b = _a.headerVideo, headerVideo = _b === void 0 ? '' : _b, _c = _a.coverImage, coverImage = _c === void 0 ? '' : _c, _d = _a.title, title = _d === void 0 ? '' : _d, _e = _a.subtitle, subtitle = _e === void 0 ? '' : _e;
    return (React.createElement(HeaderCardContainer, null,
        React.createElement("div", { className: "header_item_image" },
            React.createElement(BrandclubVideo, { videoUrl: headerVideo, posterUrl: coverImage })),
        React.createElement(HeaderItemDesc, { className: "header_item_desc" },
            React.createElement("div", { className: "title" }, title),
            React.createElement("div", { className: "subtitle" }, subtitle))));
};
var HeaderItemCard = function (_a) {
    var _b = _a.image, image = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.subtitle, subtitle = _d === void 0 ? '' : _d, _e = _a.imageLink, imageLink = _e === void 0 ? { id: '' } : _e, LinkComponent = _a.LinkComponent;
    return (React.createElement(HeaderItemCardContainer, null,
        React.createElement(LinkComponent, { style: { textDecoration: 'none' }, to: imageLink.id || '' },
            React.createElement("div", { className: "header_item_image" },
                React.createElement("img", { src: image, alt: "h_i_i" })),
            React.createElement(HeaderItemDesc, { className: "header_item_desc" },
                React.createElement("div", { className: "title" }, title),
                React.createElement("div", { className: "subtitle" }, subtitle)))));
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BrandHeaderWithMultipleVideos = function (_a) {
    var _b = _a.headerTitle, headerTitle = _b === void 0 ? '' : _b, _c = _a.headerSubtitle, headerSubtitle = _c === void 0 ? '' : _c, _d = _a.headerVideo, headerVideo = _d === void 0 ? '' : _d, _e = _a.coverImage, coverImage = _e === void 0 ? '' : _e, _f = _a.title, title = _f === void 0 ? '' : _f, _g = _a.subtitle, subtitle = _g === void 0 ? '' : _g, items = _a.items, LinkComponent = _a.LinkComponent;
    return (React.createElement(HeaderContainer, null,
        React.createElement(PreloadFonts, null),
        React.createElement(HeroContainer, null,
            React.createElement(HeaderDetails, null,
                headerTitle ? React.createElement("div", { className: "title" }, headerTitle) : null,
                headerSubtitle ? React.createElement("div", { className: "desc" }, headerSubtitle) : null),
            React.createElement(HeaderContentContainer, null,
                React.createElement(HeaderCard, { headerVideo: headerVideo, coverImage: coverImage, title: title, subtitle: subtitle }),
                items.map(function (item, idx) {
                    return (React.createElement(HeaderItemCard, { key: idx, image: item.image, title: item.title, subtitle: item.subtitle, imageLink: item.imageLink, LinkComponent: LinkComponent }));
                })))));
};

export { BrandHeaderWithMultipleVideos };
//# sourceMappingURL=index.js.map
